export default {
  crcs: [],
  filtros: {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [false],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
  },
  colunasCabecalhoCRC: [
    {
      value: 'nomeEmpresa',
      i18n: 'depositante',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'codigoCrc',
      i18n: 'codigoCRC',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'TextFilter',
      tooltip: true,
    },
    {
      value: 'estadoCrc',
      i18n: 'estadoCRC',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'SetFilter',
      filterParams: { filterSet: ['FATURADO', 'CALCULADO'], field: 'estadoCrc' },
      tooltip: true,
    },
    {
      value: 'dataInicio',
      i18n: 'dataInicio',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'dataFim',
      i18n: 'dataFim',
      text: '',
      sortable: true,
      filterable: true,
      filterComponent: 'DateFilter',
      tooltip: true,
    },
    {
      value: 'valorTotal',
      i18n: 'valorTotal',
      text: '',
      sortable: true,
      tooltip: true,
    },
  ],
};
